module.exports = __webpack_public_path__ + "static/media/email.67bc554f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/email.svg
// module id = 2474
// module chunks = 0